import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import {
    dateClassRule,
    dateFormatter,
    dateValueGetter,
    dateFilterParams,
    dateComparator,
} from "@icarius-table/date";
import { numberComparatorMax2, numberFilterParams, createNumberFormatter } from "@icarius-table/number";

export default () => [
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("employeeCode"),
            field: "CODIGO DE EMPLEADO",
            filter: "agTextColumnFilter",
            chartDataType: "series",
            checkboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelection: function (params) {
                return params.columnApi.getRowGroupColumns().length === 0;
            },
            headerCheckboxSelectionFilteredOnly: true,
            enableRowGroup: true,
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("nameAndSurname"),
            field: "APELLIDO Y NOMBRE",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("state"),
            field: "ESTADO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("icariusAccess"),
            field: "HABILITAR EL ACCESO A ICARIUS",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("internalNumber"),
            field: "NRO INTERNO",
            filter: "agTextColumnFilter",
            cellClass: "stringType"
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("incomeDate"),
            field: "FECHA DE INGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("position"),
            field: "CARGO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("fType"),
            field: "TIPO DE FUNCIONARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("jobLocation"),
            field: "LUGAR DE TRABAJO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("filterObra o Faena"),
            field: "OBRA O FAENA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("costCenter"),
            field: "CENTRO DE COSTO",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("email"),
            field: "EMAIL",
            filter: "agTextColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("personalEmail"),
            field: "EMAIL PERSONAL",
            filter: "agTextColumnFilter",
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("workMode"),
            field: "MODALIDAD DE TRABAJO",
            filter: "agSetColumnFilter",
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("cellphone"),
            field: "CELULAR",
            filter: "agTextColumnFilter",
            valueGetter: function (params) {
                return (params.data && (params.data["CELULAR"] || getLocalizedString("notAvailable"))) || "";
            },
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("plantPersonnel"),
            field: "PERSONAL DE PLANTA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("outcomeDate"),
            field: "FECHA DE EGRESO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("positionAssignmentDateAlt"),
            field: "FECHA ASIGNACION CARGO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("unitAssignationDate"),
            field: "FECHA ASIGNACION DIVISION",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("assignmentDateToFunction"),
            field: "FECHA ASIGNACION FUNCION",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("workLocationAssignmentDate"),
            field: "FECHA ASIGNACION LUGAR DE TRABAJO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("costCenterAssignmentDate"),
            field: "FECHA ASIGNACION CENTRO DE COSTO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("bornDateVisibleShort"),
            field: "FECHA DE NACIMIENTO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("shiftAssignmentDate"),
            field: "FECHA ASIGNACION TURNO",
            filter: "agTextColumnFilter",
            comparator: dateComparator,
            filterParams: dateFilterParams(),
            cellClassRules: dateClassRule,
            valueFormatter: dateFormatter,
            valueGetter: dateValueGetter,
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("legalTerminationReason"),
            field: "MOTIVO TERMINO LEGAL",
            filter: "agSetColumnFilter",
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("calculationTerminationReason"),
            field: "MOTIVO TERMINO CALCULO",
            filter: "agSetColumnFilter",
            hide: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("function"),
            field: "FUNCION",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("category"),
            field: "CATEGORIA",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("specialty"),
            field: "ESPECIALIDAD",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("civilState"),
            field: "ESTADO CIVIL",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("sex"),
            field: "SEXO",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("nationality"),
            field: "NACIONALIDAD",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("comuna"),
            field: "COMUNA",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("region"),
            field: "REGION",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("contractType"),
            field: "TIPO DE CONTRATO",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("SHOW_DIVISION"),
            field: "DIVISION",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("management"),
            field: "GERENCIA",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("department"),
            field: "DEPARTAMENTO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("section"),
            field: "SECCION",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("salaryUnit"),
            field: "UNIDAD SALARIAL",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("jornadaType"),
            field: "TIPO DE JORNADA",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("hoursPerDay"),
            field: "HORAS DIARIAS CONTRATO",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("weeklyHoursContract"),
            field: "HORAS SEMANALES CONTRATO",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("hoursPerMonth"),
            field: "HORAS MENSUALES CONTRATO",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("coin"),
            field: "MONEDA",
            filter: "agSetColumnFilter",
            enableRowGroup: true,
            hide: true,
            chartDataType: "series",
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("salary"),
            field: "SUELDO BASICO",
            filter: "agTextColumnFilter",
            comparator: numberComparatorMax2,
            filterParams: numberFilterParams(),
            chartDataType: "series",
            hide: true,
            cellClass: "currencyValue",
            valueFormatter: createNumberFormatter(2),
            enableValue: true,
            allowedAggFuncs: ["sum", "min", "max", "avg"],
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("laborUnion"),
            field: "SINDICATO",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("shift"),
            field: "TURNO",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("calendarType"),
            field: "TIPO DE CALENDARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("scheduleControlType"),
            field: "TIPO DE CONTROL HORARIO",
            filter: "agSetColumnFilter",
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        }
    },
    {
        pages: [paths.myPeople],
        config: {
            headerName: getLocalizedString("contratista"),
            field: "CONTRATISTA",
            filter: "agSetColumnFilter",
            hide: true,
            chartDataType: "series",
            enableRowGroup: true,
            enableValue: true,
        },
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("retirementDefinition"),
            field: "INSTITUCION DE PREVISION",
            filter: "agSetColumnFilter",
        }
    },
    {
        pages: [paths.myPeople],
        config:
        {
            headerName: getLocalizedString("health"),
            field: "INSTITUCION DE SALUD",
            filter: "agSetColumnFilter",
        }
    },
]